import React, { useState } from 'react';
import cx from 'classnames';
import { useTranslations } from '@unisporkal/localization';
import { useTheme } from '@unisporkal/themes';
import useNotes from '../../../hooks/stateful/useNotes';

import styles from './Notes.module.scss';
import useFormValidationError from '../../../hooks/stateful/useFormValidationError';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';

const Notes = () => {
  const t = useTranslations();
  const theme = useTheme();
  const themeTextField = theme.textField || {};
  const [isFocused, setIsFocused] = useState(false);
  const [wasClicked, setWasClicked] = useState(false);
  const [textValue, setTextValue] = useState('');
  const { selectedOption } = useSelectedIndex();
  const { formValidationError } = useFormValidationError();
  const { setNotes } = useNotes();

  const agreementViewOnlyPermissions =
    !selectedOption?.effectivePermissions?.includes('Download');
  const showNotes = selectedOption && !agreementViewOnlyPermissions;

  const isValid = selectedOption?.notesRequired ? textValue.length > 0 : true;
  const notesFormValidationError = formValidationError && !isValid;
  const shouldDisplayErrorMessage = wasClicked
    ? !isValid
    : notesFormValidationError && !isFocused;

  const errorMessage = () => {
    if (shouldDisplayErrorMessage) {
      return (
        <div
          className={styles.alertText}
          data-testid="error-message"
        >
          {t('enter_required_info')}
        </div>
      );
    }
    return null;
  };

  const handleOnChange = (e) => {
    setTextValue(e.target.value);
    setNotes(e.target.value);
    if (textValue.length > 0) {
      setIsFocused(true);
    }
  };

  const handleBlur = () => {
    setWasClicked(true);
    if (textValue.length === 0) {
      setIsFocused(false);
    }
  };

  const notesInput = () => (
    <div
      id="buy-notes"
      data-testid="buy-notes"
      className={cx(
        themeTextField.textField,
        isFocused ? themeTextField.isActive : '',
        styles.notes
      )}
    >
      <label
        className={cx(themeTextField.textFieldLabel, styles.label)}
        htmlFor="buy-notes"
        data-testid="notes-label"
      >
        {selectedOption.notesRequired ? t('notes_required') : t('notes')}
      </label>
      <input
        className={cx(themeTextField.textFieldInput, styles.text)}
        type="text"
        required={selectedOption.notesRequired}
        value={textValue}
        onFocus={() => setIsFocused(true)}
        onChange={handleOnChange}
        onBlur={handleBlur}
        id="notes"
      />
    </div>
  );

  if (!selectedOption) {
    return null;
  }

  if (showNotes) {
    return (
      <div
        className={styles.container}
        data-testid="notes-container"
      >
        {errorMessage()}
        {notesInput()}
      </div>
    );
  }
  return null;
};

export default Notes;
